<template>
  <Modal :show="show" role="alertdialog" size="lg">
    <form
      @submit.prevent="handleConfirm"
      class="mx-auto bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
    >
      <slot>
        <ModalHeader v-text="userName+', Please see your notifications below'" />
        <ModalContent style="max-height: 525px; overflow: auto">
            <section v-if="todayNotifications.length > 0">
                <h4>Notifications</h4>
                <DashboardBellNotificationList
                    :todayNotifications="todayNotifications"
                />
            </section>
            <section v-if="notifications.length > 0">
                <h4>Note/Events</h4>
                <DashboardNotificationList
                    :notifications="notifications"
                />
            </section>
        </ModalContent>
      </slot>

      <ModalFooter>
        <div class="ml-auto">
            <Button
                type="submit"
                ref="confirmButton"
                dusk="confirm-delete-button"
                :loading="false"
                state="default"
                :label="'Acknowledge'"
            />
        </div>
      </ModalFooter>
    </form>
  </Modal>
</template>

<script>
import { Button } from 'laravel-nova-ui'
import {mapGetters} from "vuex";
export default {
    components: {
        Button,
    },
  emits: ['confirm', 'close'],

  props: {
    show: { type: Boolean, default: false },
    notifications: { type: Object, default: {} },
      todayNotifications: { type: Object, default: {} },
  },
    computed: {
        ...mapGetters(['currentUser']),

        userName() {
            return (
                this.currentUser.name || this.currentUser.email || this.__('Nova User')
            )
        },
    },
  methods: {
    handleConfirm() {
        this.$emit('confirm')
    },
  },
}
</script>
